export default __webpack_public_path__ + "a01e98ffca586a28d9f3c3bd1f3ef851.svg";